import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Grid, Typography } from '@material-ui/core';

import GridContainer from './actionablelabel.styles';
import CheckboxWidget from '../CheckboxWidget';
import SelectWidget from '../SelectWidget';
import ToggleSwitchWidget from '../ToggleSwitchWidget';
import RadioGroupWidget from '../RadioGroupWidget';
import TextFieldWidget from '../TextFieldWidget';
import TextFieldBlurWidget from '../TextFieldBlurWidget';

const Widgets = {
	CheckboxWidget,
	RadioGroupWidget,
	SelectWidget,
	TextFieldWidget,
	ToggleSwitchWidget,
	TextFieldBlurWidget,
};

const Tag = ({ label }) => (
	<Typography component="span" variant="body1" className="tag">
		{label}
	</Typography>
);

Tag.propTypes = {
	label: PropTypes.string,
};

const ActionableLabel = props => {
	const {
		className,
		component,
		disabled,
		label,
		description,
		name,
		onClick,
		onChange,
		onBlur,
		options,
		tag,
		value,
		widgetType,
		widgetProps = {},
	} = props;

	const UIWidget = Widgets[widgetType] || component;
	return (
		<GridContainer
			className={classNames({ disabled }, className)}
			alignItems="center"
		>
			<Grid item xs={8}>
				<div className="label">
					<Typography variant="body1">{label}</Typography>
					{tag && <Tag label={tag} />}
				</div>
				{description && (
					<Typography variant="body1" className="description">
						{description}
					</Typography>
				)}
			</Grid>
			{UIWidget && (
				<Grid item xs={4} className="widget">
					<UIWidget
						{...{
							...widgetProps,
							disabled,
							name,
							value,
							onClick,
							onChange,
							onBlur,
							options,
						}}
					/>
				</Grid>
			)}
		</GridContainer>
	);
};

ActionableLabel.propTypes = {
	className: PropTypes.string,
	component: PropTypes.elementType,
	disabled: PropTypes.bool,
	label: PropTypes.node,
	description: PropTypes.node,
	name: PropTypes.string,
	onClick: PropTypes.func,
	onChange: PropTypes.func,
	onBlur: PropTypes.func,
	options: PropTypes.array,
	tag: PropTypes.string,
	value: PropTypes.any,
	widgetType: PropTypes.string,
	widgetProps: PropTypes.object,
};

export default memo(ActionableLabel);
